<template>
  <v-container v-if="!loadingProduto">
    <v-row dense>
      <v-col cols="12" sm="8">
        <px-autocomplete-fornecedor class="required rounded-tag-small"
                                    dense
                                    show-cnpj
                                    show-codigo
                                    show-endereco
                                    v-model="fornecedor"
                                    path="fornecedor/score"
                                    :error="$v.fornecedor.$error"
                                    @blur="$v.fornecedor.$touch()"/>
      </v-col>
      <v-col cols="12" sm="2">
        <v-text-field
            outlined
            required
            dense
            hide-details
            maxlength="50"
            class="rounded-tag-small"
            label="Código de referência"
            v-model="codigoInterno"/>
      </v-col>
      <v-col cols="12" sm="1">
        <div class="d-flex align-center">
          <v-switch dense
                    hide-details
                    class="pa-0 mt-2"
                    label=""
                    color="primary"
                    v-model="homologado"/>
          <v-tooltip top>
            <template v-slot:activator="{ on }">
              <v-icon v-on="on" class="pa-0 mt-2">
                mdi-information-outline
              </v-icon>
            </template>
            <span>
              Ative para que o fornecedor seja homologado ao produto
            </span>
          </v-tooltip>
        </div>
      </v-col>
      <v-col cols="12" sm="1" align-self="center">
        <v-btn color="primary"
               small
               class="normal-btn-text rounded-tag-small elevation-0"
               @click="onClickAdd">
          <v-icon x-small>mdi-plus</v-icon>
          Adicionar
        </v-btn>
      </v-col>
    </v-row>
    <v-row dense>
      <v-col cols="12" v-if="produto.fornecedores.length > 0">
        <px-lista-fornecedor :fornecedores="produto.fornecedores"
                             :loading="loading"
                             @update="getFornecedores"
                             @remove="onRemove($event)"
                             @change-homologado="onChangeHomologado"/>
      </v-col>
    </v-row>
  </v-container>
</template>
<script>
import validationMixin from '@/mixins/validation-mixin';
import { orderBy } from 'lodash';
import { required } from 'vuelidate/lib/validators';
import FornecedorService from '../fornecedor-produto-service';
import ListaFornecedor from '../ListaFornecedor.vue';

export default {
  mixins: [validationMixin],
  props: {
    produto: Object,
    loadingProduto: Boolean,
  },
  data() {
    return {
      fornecedor: null,
      codigoInterno: null,
      homologado: null,
      loading: false,
      loadingUpdate: false,
    };
  },
  methods: {
    onChangeHomologado(fornecedor) {
      this.save(fornecedor, true);
    },
    sortFornecedores() {
      this.produto.fornecedores = orderBy(this.produto.fornecedores, 'fornecedor.pessoa.nome', 'asc');
    },
    buildFornecedor(fornecedor) {
      return {
        produto: {
          id: this.produto.id,
        },
        fornecedor: {
          id: fornecedor.id,
          pessoa: { ...fornecedor.pessoa },
          site: fornecedor.site,
          disabled: fornecedor.disabled,
        },
        codigoInterno: this.codigoInterno,
        homologado: this.homologado,
      };
    },
    buildQueryFornecedor() {
      if (this.produto.id) {
        return `produto.id = ${this.produto.id}`;
      }
      return '';
    },
    buildParams() {
      return {
        params: {
          limit: 10,
          offset: 0,
          query: this.buildQueryFornecedor(),
        },
      };
    },
    getFornecedores() {
      this.loading = true;

      FornecedorService.get(this.buildParams())
        .then((response) => {
          this.produto.fornecedores = response.data.content;
          this.sortFornecedores();
        })
        .finally(() => {
          this.loading = false;
        });
    },
    hasFornecedorAdicionado() {
      return this.produto.fornecedores
        .map(fornecedor => fornecedor.fornecedor.id)
        .includes(this.fornecedor.id) && !this.produto.id;
    },
    clearCadastros() {
      this.fornecedor = null;
      this.codigoInterno = null;
      this.homologado = false;
    },
    onClickAdd() {
      if (this.validateForm()) {
        return;
      }
      if (this.hasFornecedorAdicionado()) {
        this.$toast(`Fornecedor ${this.fornecedor.pessoa.nome} já incluso`, { color: 'error' });
        this.fornecedor = null;
        return;
      }
      if (!this.produto.id) {
        this.produto.fornecedores.push(this.buildFornecedor(this.fornecedor));
        this.clearCadastros();
        this.sortFornecedores();
        return;
      }
      this.save(this.buildFornecedor(this.fornecedor));
    },
    save(fornecedor, isUpdateHomologado) {
      this.loadingUpdate = true;

      const message = isUpdateHomologado ? 'Fornecedor atualizado com sucesso!' : 'Fornecedor adicionado ao produto com sucesso!';

      FornecedorService.save(fornecedor)
        .then(() => {
          this.$toast(message, { color: 'success' });
          this.clearCadastros();
        })
        .finally(() => {
          this.loadingUpdate = false;
          this.getFornecedores();
        });
    },
    getIndexFornecedorById(idFornecedor) {
      return this.produto.fornecedores
        .map(fornecedorAdicionado => fornecedorAdicionado.fornecedor.id)
        .indexOf(idFornecedor);
    },
    onRemove(fornecedor) {
      if (!this.produto.id) {
        const index = this.getIndexFornecedorById(fornecedor.id);
        this.produto.fornecedores.splice(index, 1);
        return;
      }
      this.remove(fornecedor);
    },
    remove(fornecedor) {
      this.loadingUpdate = true;
      FornecedorService.remover(fornecedor.id)
        .then(() => {
          this.$toast('Fornecedor removido', { color: 'success' });
        })
        .finally(() => {
          this.loadingUpdate = false;
          this.getFornecedores();
        });
    },
  },
  validations: {
    fornecedor: {
      required,
    },
  },
  components: {
    pxListaFornecedor: ListaFornecedor,
  },
};
</script>
